// Helper function to get the error message based on field name (code)
export const getErrorMessage = (fieldName, errors) => {
    // Ensure errors is an array and not null or undefined
    if (!Array.isArray(errors)) {
      console.error("Invalid errors array:", errors); // Log the invalid errors array
      return null; // Return null if errors is not an array
    }
  
    const error = errors.find((err) => err.code === fieldName);
    return error ? error.message : null; // Return the error message if found, else null
  };
  

    // Utility function to update error message for a field
    export const updateError = (field, message, errors) => {
        const existingErrorIndex = errors.findIndex((error) => error.code === field);
        if (existingErrorIndex > -1) {
          // Update existing error
          const updatedErrors = [...errors];
          updatedErrors[existingErrorIndex] = { code: field, message };
          return updatedErrors;
        }
        // Add new error
        return [...errors, { code: field, message }];
      };
      
      // Utility function to clear error for a field
    export  const clearError = (field, errors) => {
        return errors.filter((error) => error.code !== field);
      };